import { useMutation } from '@tanstack/react-query';
import type { IRetainerPDFParams } from 'api/resources/RetainerPDF';
import { getRetainerPDF } from 'api/resources/RetainerPDF';

export const useGetRetainerPDF = () =>
	useMutation({
		mutationKey: ['getRetainerPDF'],
		mutationFn: (params: IRetainerPDFParams) => getRetainerPDF(params),
	});
